<script lang="typescript">
import { createEventDispatcher, onDestroy, onMount, tick } from 'svelte';
import Quill, { QuillOptionsStatic } from "quill";
import { crossfade, fade, fly, slide } from 'svelte/transition';
import Fa from "svelte-fa";

import type { Letter } from '../models/Letter';
import { Lead } from '../models/Lead';
import { quintOut } from 'svelte/easing';
import { flip } from 'svelte/animate';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { EditorMode } from '../models/EditorMode';
export let letter: Letter;
export let currentLetterIndex: number;
export let currentMode: EditorMode;
export let fullWidth = false;
export let leftRight: string;
export let readOnlyMode: boolean = false;

let copyContentsButton;
const BOUNDS_CONTAINER = '#editorContainer' + leftRight;
const SELECTOR_CONTAINER = '#copyEditor' + leftRight;
var toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  ['blockquote'],

  [{ 'header': 1 }, { 'header': 2 }],               // custom button values
  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
  [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
//   [{ 'direction': 'rtl' }],                         // text direction

//   [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
//   [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  [{ 'background': [] }],
  ['clean']                                         // remove formatting button
];
let placeholder = "Write copy here..."
if(readOnlyMode) {
    placeholder = ""
}
let copyOptions: QuillOptionsStatic = { 
    placeholder: placeholder,
    theme: "bubble",
    readOnly: readOnlyMode,
    // scrollingContainer: SELECTOR_CONTAINER,
    bounds: SELECTOR_CONTAINER,
    modules: {
        toolbar: toolbarOptions
    }
}
console.log(copyOptions)
var copyEditor: Quill;
const [send, receive] = crossfade({
		duration: d => Math.sqrt(d * 200),

		fallback(node, params) {
			const style = getComputedStyle(node);
			const transform = style.transform === 'none' ? '' : style.transform;

			return {
				duration: 600,
				easing: quintOut,
				css: t => `
					transform: ${transform} scale(${t});
					opacity: ${t}
				`
			};
		}
});

let editorContainer : HTMLElement;
let copyDiv : HTMLElement;
let leadInputElement : HTMLElement;
let leadsDiv: HTMLElement;
onMount(()=>{
    // copyDiv = document.getElementById("copyEditor")
    resetQuill();
})
const dispatch = createEventDispatcher();
function saveLetter(letter: Letter) {
    if(letter && letter.id){
        dispatch('saveletter', {
            prop: letter.id
        });
    }
}
onDestroy(()=>{
copyDiv.innerHTML = "";
})

$:saveLetter(letter);
$:resetLetterContent(currentLetterIndex)
$:{
    if((currentMode === EditorMode.COPY && leftRight == "R" ) || currentMode === EditorMode.WRITING){
        console.log("resetting quill for mode....")
        // setTimeout(() => resetQuill(), 1000);
        // resetQuill();
    }
}

function resetLetterContent(index){
    if(copyEditor && copyEditor.root && copyEditor.root.innerHTML){
        copyEditor.root.innerHTML = letter.content;
        console.log(letter.content)
        // resetQuill();
    }
}

async function clearLeadFormatting(){
    await tick();
    setTimeout(()=>{
        const text = strip(leadInputElement.innerHTML)
        leadInputElement.innerHTML = text
    }, 50)

    // tick().then(()=>{
    //     leadInputElement.innerHTML = text
    // })
}

function strip(html: string){
   html.replace(/(<([^>]+)>)/gi, "") || "";
   let doc = new DOMParser().parseFromString(html, 'text/html');
   return doc.body.textContent || "";
}

let focusMode = false;
async function toggleFullScreen() {
  if (!document.fullscreenElement) {
      await copyDiv.requestFullscreen();
      document.fullscreenElement.onfullscreenchange = ((evt) =>{
        if (!document.fullscreenElement) {
            focusMode = false;
            resetQuill();
        }else{
            if (document.exitFullscreen) {
                focusMode = true;
                resetQuill();
            }
        }
      })
      focusMode = true;
      resetQuill()
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
      focusMode = false;
      resetQuill();
    }
  }
}

function copyFormattedLetter () {
  const lead = `<h1>${leadInputElement.innerHTML}</h1>`
  const copyContents = lead + letter.content;
  var container = document.createElement('div');
  container.innerHTML = copyContents;
  container.style.position = 'fixed'
  container.style.pointerEvents = 'none'
  var activeSheets = Array.prototype.slice.call(document.styleSheets)
    .filter(function (sheet) {
      return !sheet.disabled
    })
  document.body.appendChild(container)
  window.getSelection().removeAllRanges()
  var range = document.createRange()
  range.selectNode(container)
  window.getSelection().addRange(range)
  document.execCommand('copy')
  for (var i = 0; i < activeSheets.length; i++) activeSheets[i].disabled = true
  document.execCommand('copy')
  for (var i = 0; i < activeSheets.length; i++) activeSheets[i].disabled = false
  document.body.removeChild(container)
  copied = true;
  setTimeout(()=>{
      copied = false;
  }, 2500)
}
let copied = false;
function addLead(){
    console.log("add lead")
    const newLead = new Lead();
    console.log(newLead)
    letter.leads = [...letter.leads, newLead];
    // letter.leads.push(newLead);
    letter.selectedLead = letter.leads.length-1;
}

function resetQuill(){
    if(copyDiv){
        copyEditor = new Quill(SELECTOR_CONTAINER, copyOptions)
        copyDiv.insertBefore(leadInputElement, copyDiv.firstChild)
        copyDiv.insertBefore(leadsDiv, copyDiv.firstChild)
        copyEditor.root.innerHTML = letter.content;

        copyEditor.on("text-change", (delta) =>{
            letter.content = copyEditor.root.innerHTML;
        })
    } else{
        console.log("Editor div unavailable for reset.")
        setTimeout(resetQuill, 2000)
    }
}
</script>
<!-- <svelte:window on:keydown={(evt)=>captureEscape(evt)}/> -->
<div in:fade={{delay: 400, duration: 400}} out:fade={{duration:400}} 
bind:this={editorContainer}
id="editorContainer{leftRight}"
class="editorContainer {fullWidth? "w-screen" : "halfScreen"}">
     <div class="leadsDiv sticky top-0 bg-primary" bind:this={leadsDiv}>
        <label for="leads">Leads:</label>
        {#each letter.leads as lead, i (i)}

        <button
        in:receive={{key: i}}
        out:send={{key: i}}
        animate:flip
        on:click={()=>letter.selectedLead = i}
        class="h-8 px-2 text-sm
         {letter.selectedLead == i ? "bg-third text-white" : "bg-none text-gray-800 border-2 border-gray-800"}  transition-colors duration-150 rounded-lg cursor-pointer focus:shadow-outline hover:bg-indigo-800 hover:text-white mr-2
         focus:outline-none">
            Lead {i + 1}
        </button>
        {/each}
        <button
        on:click={addLead}
        disabled={letter.leads.length >= 5 || readOnlyMode}
         class="h-8 px-2 text-lg
         bg-none text-gray-800 border-2 border-gray-800 transition-colors duration-150 rounded-lg cursor-pointer  focus:ring-transparent hover:bg-indigo-800 focus:outline-none hover:text-white
         disabled:opacity-50
         {letter.leads.length >= 5 ? 'pointer-events-none' : ''}
        ">
           +
       </button>
       <button class="
       text-white
       hover:bg-red-300 
       p-1 
       float-right justify-self-end 
       {focusMode? "bg-danger" : "bg-third"}
        mr-1
       rounded-lg" on:click={toggleFullScreen}>{focusMode? "Exit" : "Focus Mode"}
      </button>
       <button bind:this={copyContentsButton}
       on:click={copyFormattedLetter}
       class="
       text-white
       hover:bg-red-300 
       p-2 
       float-right 
       tooltip
       mr-1
       rounded-lg">
       <Fa icon={faCopy} color="black" size="lg" swapOpacity={false} />
       <span class="tooltiptext">{copied ? "Copied!" : "Copy contents" }</span>
      </button>

       <br/>

    </div>
    <h3 
    bind:this={leadInputElement}
    id="leadInputElement"
    rows="1"
    bind:textContent={letter.leads[letter.selectedLead].content}
    on:paste={clearLeadFormatting}
    on:focus={(evt)=>{
        if(readOnlyMode){
            evt.currentTarget.blur();
        }
    }}
    class="leadInput
    ml-auto mr-auto
    text-2xl mt-2 text-center"
    contenteditable="true"
    placeholder="Enter new lead here..."
    />
    <div bind:this={copyDiv} class="editor {fullWidth || focusMode ? "md:px-30 lg:px-44 xl:px-72" : ""}
    {fullWidth? "w-screen" : "halfScreen"} bg-primary" 
    id="copyEditor{leftRight}"/>
</div>
    
<svelte:head>
    <!-- <link href="//cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet"> -->
    <!-- <link href="//cdn.quilljs.com/1.3.6/quill.bubble.css" rel="stylesheet"> -->
    <link href="/quill.bubble.css" rel="stylesheet">

</svelte:head>
<style>
/* .ql-editor.ql-blank::before{
    position: relative !important;
} */

.ql-editor {
    max-height: 83vh;
    min-height: fit-content;
}

.leadInput:empty:before {
  content: attr(placeholder);
  pointer-events: none;
  color: grey;
  display: block; 
}

.leadInput {
    width: 95%;
    font: monospace;
    @apply rounded bg-transparent border-black p-2 border-b-2;
}

label{
    font-weight:bold;
}
.halfScreen {
    width: 50vw;
}
.editorContainer{
    display: flex;
    /* flex-direction: column; */
    flex: 1;
    max-height: 83vh;
    /* @apply border-black border-solid border-r-2 border-l-2 */
}

.editorContainer:fullscreen {
    @apply bg-primary;
}
.editorContainer:-webkit-full-screen {
    @apply bg-primary;
}
.editorContainer:-moz-full-screen {
    @apply bg-primary;
}

.tabContainer{
    display: flex;
    flex-direction: row;
}
.tab{
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
}

.active {
    border: black 1px solid;
    border-radius: 5px 5px 0px 0px;
}
.inactive{
    color: rgba(255, 255, 255, 0.657);
    background-color: peachpuff;
}
.editor{
    font-family: monospace;
    font-size: x-large;
    flex: 100vmax;
    overflow-y: scroll;
}

.activeEditor{
    height:100%;
}

.inactiveEditor{
    display: none;
}

.leadsDiv{
    @apply pt-1;
    @apply pb-1;
    padding-left: 10px;
    flex: content;
    /* border-left: black 2px solid;
    border-right: black 2px solid;
    border-top: black 1px solid; */
}

h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
}
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  margin-left: -60px;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>